var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0385 3.69238C7.4904 3.69238 5.4231 5.75969 5.4231 8.30777V23.6924C5.4231 26.2405 7.4904 28.3078 10.0385 28.3078H23.8846H25.4231H26.9616V25.2308H25.4231V22.1539H26.9616V3.69238H25.4231H23.8846H10.0385ZM10.0385 22.1539H22.3462V25.2308H10.0385C9.18752 25.2308 8.50002 24.5433 8.50002 23.6924C8.50002 22.8414 9.18752 22.1539 10.0385 22.1539ZM18.1154 13.3078L19.2692 10.6155L20.4231 13.3078L23.1154 14.4616L20.4231 15.6155L19.2692 18.3078L18.1154 15.6155L15.4231 14.4616L18.1154 13.3078ZM13.8846 6.76931L14.6539 8.30777L16.1923 9.077L14.6539 9.84623L13.8846 11.3847L13.1154 9.84623L11.5769 9.077L13.1154 8.30777L13.8846 6.76931Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.6c7886ad3c4944ed47af03b4be86d554.svg";
export { ForwardRef as ReactComponent };